"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeKeybindRequestT = exports.ChangeKeybindRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const keybind_js_1 = require("../../solarxr-protocol/rpc/keybind.js");
class ChangeKeybindRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsChangeKeybindRequest(bb, obj) {
        return (obj || new ChangeKeybindRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsChangeKeybindRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ChangeKeybindRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    keybind(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new keybind_js_1.Keybind()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startChangeKeybindRequest(builder) {
        builder.startObject(1);
    }
    static addKeybind(builder, keybindOffset) {
        builder.addFieldOffset(0, keybindOffset, 0);
    }
    static endChangeKeybindRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createChangeKeybindRequest(builder, keybindOffset) {
        ChangeKeybindRequest.startChangeKeybindRequest(builder);
        ChangeKeybindRequest.addKeybind(builder, keybindOffset);
        return ChangeKeybindRequest.endChangeKeybindRequest(builder);
    }
    unpack() {
        return new ChangeKeybindRequestT((this.keybind() !== null ? this.keybind().unpack() : null));
    }
    unpackTo(_o) {
        _o.keybind = (this.keybind() !== null ? this.keybind().unpack() : null);
    }
}
exports.ChangeKeybindRequest = ChangeKeybindRequest;
class ChangeKeybindRequestT {
    constructor(keybind = null) {
        this.keybind = keybind;
    }
    pack(builder) {
        const keybind = (this.keybind !== null ? this.keybind.pack(builder) : 0);
        return ChangeKeybindRequest.createChangeKeybindRequest(builder, keybind);
    }
}
exports.ChangeKeybindRequestT = ChangeKeybindRequestT;
